import React, { useState } from 'react';
import { Trash2, Shield } from 'lucide-react';
import axios from 'axios';

const PrivacyDataTab = ({ onError, onSuccess }) => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [confirmText, setConfirmText] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleDeleteRequest = async () => {
    if (confirmText.trim().toUpperCase() !== 'ELIMINAR') {
      onError?.('Escribí ELIMINAR para confirmar');
      return;
    }
    setSubmitting(true);
    try {
      await axios.post('/api/user/account-deletion-request', {});
      onSuccess?.('Recibimos tu solicitud de eliminación. Te contactaremos a la brevedad.');
      setShowDeleteModal(false);
      setConfirmText('');
    } catch (err) {
      console.error(err);
      onError?.(err.response?.data?.error || 'No se pudo enviar la solicitud');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="backdrop-blur-xl bg-gradient-to-br from-slate-800/90 via-slate-900/90 to-indigo-900/90 border border-white/20 rounded-2xl shadow-lg p-4 md:p-8">
      <div className="pb-6 border-b border-white/10">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-blue-500/40 flex items-center justify-center backdrop-blur-md">
            <Shield className="w-5 h-5 text-white" aria-hidden />
          </div>
          <div>
            <h3 className="text-white font-bold text-lg">Privacidad y datos</h3>
            <p className="text-white/70 text-sm">
              Gestioná la eliminación de tu cuenta y los datos asociados.
            </p>
          </div>
        </div>
      </div>

      <div className="space-y-8 pt-6 md:pt-8">
        <section className="space-y-4">
          <h4 className="text-white/90 font-semibold text-sm uppercase tracking-wide">
            Eliminar cuenta
          </h4>
          <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between md:gap-8 rounded-xl border border-white/10 bg-white/5 p-4 md:p-5">
            <p className="text-white/70 text-sm md:text-base">
              Solicitá la eliminación permanente de tu cuenta y los datos asociados. Esta acción se
              procesa manualmente; te contactaremos si hace falta confirmación adicional.
            </p>
            <button
              type="button"
              onClick={() => {
                setConfirmText('');
                setShowDeleteModal(true);
              }}
              className="inline-flex shrink-0 items-center justify-center gap-2 rounded-xl px-5 py-3 bg-red-600/90 hover:bg-red-600 text-white text-sm font-medium transition-colors"
            >
              <Trash2 className="h-4 w-4" aria-hidden />
              Eliminar mi cuenta
            </button>
          </div>
        </section>
      </div>

      {showDeleteModal && (
        <div className="fixed inset-0 modal-safe-area bg-black/50 flex items-center justify-center z-50 p-4">
          <div
            role="dialog"
            aria-modal="true"
            aria-labelledby="privacy-delete-title"
            className="bg-slate-800 border border-white/20 rounded-xl p-6 max-w-sm w-full"
          >
            <h3 id="privacy-delete-title" className="text-white font-bold text-lg mb-2">
              ¿Solicitar eliminación de cuenta?
            </h3>
            <p className="text-white/70 text-sm mb-4">
              Para confirmar, escribí <span className="font-mono text-white/90">ELIMINAR</span> en el
              campo inferior. Se enviará una solicitud al equipo de espor.ai.
            </p>
            <input
              type="text"
              value={confirmText}
              onChange={(e) => setConfirmText(e.target.value)}
              placeholder="ELIMINAR"
              autoComplete="off"
              className="w-full px-4 py-3 backdrop-blur-md bg-white/10 border border-white/20 rounded-xl text-white placeholder-white/40
                focus:outline-none focus:border-blue-400 focus:bg-white/15 transition-all duration-200"
            />
            <div className="flex gap-3 mt-6">
              <button
                type="button"
                onClick={() => {
                  setShowDeleteModal(false);
                  setConfirmText('');
                }}
                className="flex-1 px-4 py-3 rounded-lg bg-white/10 hover:bg-white/20 text-white font-medium transition-colors"
              >
                Cancelar
              </button>
              <button
                type="button"
                onClick={handleDeleteRequest}
                disabled={submitting}
                className="flex-1 px-4 py-3 rounded-lg bg-red-600 hover:bg-red-700 text-white font-medium transition-colors disabled:opacity-50"
              >
                {submitting ? 'Enviando…' : 'Confirmar solicitud'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PrivacyDataTab;
